import { Centre } from '../../types/contentful-v1'

interface Entry {
  centre: Centre
}

const locationLink = (entry: Entry): string =>
  `https://www.google.com/maps/search/?api=1&query=${entry.centre.latitude},${
    entry.centre.longitude
  }`

export default locationLink
